import { UseControllerProps, useController } from "react-hook-form";
import { Flex, Select, Typography } from "@payping/web-components";
import { SelectProps } from "@payping/web-components/components/Select/types";
import classNames from "classnames";

type Props = SelectProps &
  UseControllerProps<any> & {
    label?: React.ReactNode | string;
    labelClassName?: string;
    noErrorMessage?: boolean;
  };

const RHFSelect: React.FC<Props> = ({
  name,
  control,
  defaultValue = "",
  rules,
  shouldUnregister,
  label,
  labelClassName,
  noErrorMessage,
  ...rest
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <Flex vertical className={classNames("tw-relative", { "tw-pb-[28px]": !noErrorMessage })}>
      {label && <Typography.Text className={`tw-mb-[8px] !tw-text-[14px] ${labelClassName}`}>{label}</Typography.Text>}
      <Select {...field} {...rest} status={error ? "error" : ""} />
      {error && (
        <Typography.Text type="danger" className="tw-absolute tw-bottom-[2px] tw-start-0">
          {error.message}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default RHFSelect;
